export default __webpack_public_path__ + "8a5af193d840467aa2e3f6f4085c848f.webp";